import React from 'react'

const Shimmer = () => {
  return (
    <div className="space-y-3">
  <div className="bg-slate-200/60 w-full h-16 animate-pulse mt-2 rounded-lg"></div>
  <div className="flex flex-wrap  gap-6">
    <div className="bg-slate-200/60 animate-pulse h-[85vh] w-[25%] rounded-lg"></div>

    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 w-[70%]">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="bg-slate-200/60 animate-pulse h-[39vh] rounded-lg"
        ></div>
      ))}
    </div>
  </div>
</div>

  )
}

export default Shimmer